/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Title_1Inputs */

const en_services_svc_save_title_1 = /** @type {(inputs: Services_Svc_Save_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The work that repeats.`)
};

const lv_services_svc_save_title_1 = /** @type {(inputs: Services_Svc_Save_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Darbs, kas atkārtojas.`)
};

/**
* | output |
* | --- |
* | "The work that repeats." |
*
* @param {Services_Svc_Save_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_title_1 = /** @type {((inputs?: Services_Svc_Save_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_title_1(inputs)
	return en_services_svc_save_title_1(inputs)
});